import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  formContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
    width: '60%',
    margin: '30px auto',
    '& $formField': {
      margin: '15px auto',
    },
  },
  formField: {
    margin: '15px auto',
  },
  submitButton: {
    marginTop: 20,
  },
  orContinueWith: {
    margin: 'auto 10px',
  },
  forgotPassword: {
    width: '100%',
    textAlign: 'left',
  },
  link: {
    color: theme.palette.primary.main,
  },
});

export default makeStyles(styles);
